// Action Types for SPD Report (Response Report without Late information)
export const VENDOR_REPORT_SPD_REQUEST = 'VENDOR_REPORT_SPD_REQUEST';
export const VENDOR_REPORT_SPD_SUCCESS = 'VENDOR_REPORT_SPD_SUCCESS';
export const VENDOR_REPORT_SPD_FAILURE = 'VENDOR_REPORT_SPD_FAILURE';
export const VENDOR_REPORT_SPD_RESET = 'VENDOR_REPORT_SPD_RESET';

// Initial State - NO late information
const initialState = {
    data: [],
    summary: {
        totalInvoices: 0,
        avgResponse: 0
        // No late information for SPD
    },
    loading: false,
    error: null
};

// Reducer
export default function vendorReportSPDReducer(state = initialState, action) {
    switch (action.type) {
        case VENDOR_REPORT_SPD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case VENDOR_REPORT_SPD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.invoice_data || [],
                summary: {
                    totalInvoices: (action.payload.summary_data && action.payload.summary_data.total_invoices) || 0,
                    avgResponse: (action.payload.summary_data && action.payload.summary_data.avg_response) || 0
                    // No late information for SPD
                }
            };
            
        case VENDOR_REPORT_SPD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: [],
                summary: initialState.summary
            };

        case VENDOR_REPORT_SPD_RESET:
            return initialState;
            
        default:
            return state;
    }
}

// Action Creators
export const vendorReportSPDRequest = () => ({
    type: VENDOR_REPORT_SPD_REQUEST
});

export const vendorReportSPDSuccess = (data) => ({
    type: VENDOR_REPORT_SPD_SUCCESS,
    payload: data
});

export const vendorReportSPDFailure = (error) => ({
    type: VENDOR_REPORT_SPD_FAILURE,
    payload: error
});

export const vendorReportSPDReset = () => ({
    type: VENDOR_REPORT_SPD_RESET
});